export default __webpack_public_path__ + "static/carpass_green~PIRedrvg-6c521c2c46ad8eaed23dd5b369e1db23.png";